import { FirebaseFunctionDefs, FirebaseFunctionNames } from "breadcommon";
import { getApp } from "firebase/app";
import {
  HttpsCallable,
  HttpsCallableResult,
  HttpsCallableOptions,
  getFunctions,
  httpsCallable,
} from "firebase/functions";

export function callFirebaseFunction<T extends FirebaseFunctionNames>(
  functionName: T,
  request: FirebaseFunctionDefs[T]["requestType"],
  options?: HttpsCallableOptions,
): Promise<HttpsCallableResult<FirebaseFunctionDefs[T]["responseType"]>> {
  const app = getApp();
  const functions = getFunctions(app);
  const firebaseFunction = httpsCallable(
    functions,
    functionName,
    options,
  ) as HttpsCallable<
    FirebaseFunctionDefs[T]["requestType"],
    FirebaseFunctionDefs[T]["responseType"]
  >;
  return firebaseFunction(request);
}
